import * as React from "react";
import { ContainerNetworkType } from "../../../ViewModel/ContainerNetworkType";

export default function PdsrText({
  ContainerNetwork,
  PlantGsdb,
  DockCode,
  SupplierGsdb,
}: {
  ContainerNetwork: ContainerNetworkType | undefined;
  PlantGsdb: string | undefined;
  DockCode: string | undefined;
  SupplierGsdb: string | undefined;
}) {
  return (
    <>
      {ContainerNetwork}-{PlantGsdb}-{DockCode}-{SupplierGsdb}
    </>
  );
}
